export default __webpack_public_path__ + "static/media/Air-handling-unit.d39f45a1.jpg";